<template>
  <filter-wrapper v-model="form.name" @submit="submit" />
</template>

<script>
  import FilterWrapper from '@shared/components/filter-search';
  import { mapGetters, mapActions } from 'vuex';
  import { oneOf } from 'view-design/src/utils/assist';
  import { PriceType } from '@core/models/price-type';

  export default {
    components: {
      FilterWrapper
    },

    props: {
      type: {
        type: String,
        required: true,
        validator: value => oneOf(value, PriceType.getList())
      }
    },
    data: () => ({
      form: {
        name: ''
      }
    }),

    computed: {
      ...mapGetters('core/auth', ['user'])
    },

    watch: {
      type: {
        handler: function() {
          this.submit();
        },
        immediate: true
      }
    },

    methods: {
      ...mapActions('core/prices/table', ['search']),

      submit() {
        const { name } = this.form;
        const rate_id = this.user.rates[this.type].id;

        const params = {
          search: name,
          type: this.type,
          rate_id
        };

        this.search(params);
      }
    }
  };
</script>
